import { API_NEWSSO } from 'apiConfig';
import axios from 'axios';
import qs from 'qs';
Vue.axios = axios;
// sso :API_ROOT
// 其他是 : API_NEWSSO
let api = {
    checkPhone:API_NEWSSO.concat('/ssouser/checkPhone.do'),     // 注册时检查手机号是否可用
    checkEmail:API_NEWSSO.concat('/ssouser/checkEmail.do'),     // 注册时检查邮箱是否可用
    sendPhoneCodeRegister:API_NEWSSO.concat('/ssouser/sendPhoneRegisterValicode.do'),// 注册时发送手机验证码
    register:API_NEWSSO.concat('/ssouser/register.do'), // 注册用户

    passLogin: API_NEWSSO.concat('/ssouser/login.do'),  // 密码登录

    checkPhoneFast:API_NEWSSO.concat('/ssouser/fastLoginByValdaite.do'), // 快速登录的时候检测手机号是否通过
    getPhoneCodeFastLogin:API_NEWSSO.concat('/ssouser/sendValdaiteCodeByFastLogin.do'),   // 快读登录获取手机验证码
    phoneFastLogin:API_NEWSSO.concat('/ssouser/fastLogin.do'),   // 手机快速登录


    checkPhoneFindPassword:API_NEWSSO.concat('/ssouser/sendPhoneVerificationCodeByfindPassword.do'),     // 检查手机验证码是否正确
    validatePhoneCodeForFindPassword:API_NEWSSO.concat('/ssouser/validatePhoneCodeForFindPassword.do'),   // 手机重置密码
    commitNewPass:API_NEWSSO.concat('/ssouser/findPassword.do'),     // 提交新密码

    findPasswordFast:API_NEWSSO.concat('/ssouser/findPasswordByEmail.do'),  // 邮箱找回密码
    updatePasswordByEmail:API_NEWSSO.concat('/ssouser/updatePasswordByEmail.do')  // 邮箱快速找回密码的重置

}
var instance = axios.create({
    withCredentials:true,
    crossDomain: true
})
/*
 注册时检查手机号是否可用
 */
function checkPhone(param){
    return axios.post(api.checkPhone, qs.stringify(param));
}

/*
 注册时检查邮箱是否可用
 */
function checkEmail(param){
    return axios.post(api.checkEmail, qs.stringify(param));
}

/*
 注册时发送手机验证码
 */
function sendPhoneCodeRegister(param) {
    return axios.post(api.sendPhoneCodeRegister, qs.stringify(param));
}

/*
 *   注册新用户
 */
function register(param) {
    return axios.post(api.register, qs.stringify(param));
}

/*
 密码登录
 */
function passLogin(param){
    return instance.post(api.passLogin, qs.stringify(param));
}
/*
 快速登录时检测电话号码是否通过
 */
function checkPhoneFast(param) {
    return instance.post(api.checkPhoneFast, qs.stringify(param));
}
/*
 快速登录获得手机验证码
 */
function getPhoneCodeFastLogin(param){
    return instance.post(api.getPhoneCodeFastLogin, qs.stringify(param));
}
/*
 快速登录
 */
function phoneFastLogin(param){
    return instance.post(api.phoneFastLogin, qs.stringify(param));
}
// -----
/*
 *   通过手机验证码找回密码
 */
function phoneCodeForFindPassword(param) {
    return axios.post(api.validatePhoneCodeForFindPassword, qs.stringify(param));
}

/*
    找回密码--检查手机验证码是否正确
*/
function checkPhoneFindPassword(param){
    return axios.post(api.checkPhoneFindPassword, qs.stringify(param));
}

/*
    找回密码--提交新密码
*/
function commitNewPassWord(param){
    return axios.post(api.commitNewPass, qs.stringify(param));
}

function  findPassword(param) {
    return axios.post(api.findPasswordFast, qs.stringify(param));
}

function updatePasswordEmail(param) {
    return axios.post(api.updatePasswordByEmail, qs.stringify(param));
}

module.exports = {
    checkPhone:checkPhone,
    checkEmail:checkEmail,
    sendPhoneCodeRegister:sendPhoneCodeRegister,

	   passLogin:passLogin,

    getPhoneCodeFastLogin:getPhoneCodeFastLogin,
    phoneFastLogin:phoneFastLogin,
    checkPhoneFast:checkPhoneFast,

    checkPhoneFindPassword:checkPhoneFindPassword,
    commitNewPassWord:commitNewPassWord,
    register:register,
    phoneCodeForFindPassword:phoneCodeForFindPassword,
    findPassword:findPassword,
    updatePasswordEmail:updatePasswordEmail
}



// WEBPACK FOOTER //
// ./src/service/sso/sso.server.js